import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'
import withApollo from 'react-apollo/withApollo'

import Modal from '../../../components/Modal'
import { hideModal } from '../../../redux/modal/action'
import withTranslation from '../../../providers/I18n/HoC/t'
import { withNotifications } from '../../../providers/notifications'
import Button from 'src/components/Button'

const DuplicateCookieModel = ({
    t,
    history,
    closeExampleModal
}) => {
    return (
        <Modal>
            <div className='modal_bar'>
                <h4 className='modal_title'>{t('.duplicate_cookie')}</h4>
            </div>
            <div className='modal_content'>
                {t('.duplicate_cookie_message')}

                <div className='list_buttons'>
                    <Button
                        className='btn btn_pill is-blue'
                        published
                        onClick={() => {
                            closeExampleModal();
                        }}
                    >
                        {t('.ok')}

                    </Button>
                </div>
            </div>

        </Modal>
    )
}


const mapDispatchToProps = {
    closeExampleModal: hideModal,
}
export default compose(
    connect(null, mapDispatchToProps),
    withApollo,
    withRouter,
    withNotifications(),
    withTranslation('dashboard'),
)(DuplicateCookieModel)
